export const inr = (v, dec = 0) =>
  "₹" + Number(v || 0).toLocaleString("en-IN", { minimumFractionDigits: dec, maximumFractionDigits: dec === 0 ? 0 : 2 });

export const inr2 = (v) => inr(v, 2);

export const dmy = (s) => {
  if (!s) return "-";
  const [y, m, d] = String(s).slice(0, 10).split("-");
  return d && m && y ? `${d}/${m}/${y}` : s;
};

export const todayISO = () => {
  const d = new Date();
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
};

export const addDays = (iso, n) => {
  const d = new Date(iso);
  d.setDate(d.getDate() + Number(n || 0));
  return d.toISOString().slice(0, 10);
};

export const num = (v) => {
  const n = parseFloat(v);
  return Number.isFinite(n) ? n : 0;
};

const hoursBetween = (d1, t1, d2, t2) => {
  if (!d1 || !t1 || !t2) return 0;
  const a = new Date(`${d1}T${t1}`);
  const b = new Date(`${d2 || d1}T${t2}`);
  const h = (b - a) / 3600000;
  return h > 0 ? Math.round(h * 100) / 100 : 0;
};

export function calcDuty(d) {
  const n = (k) => num(d[k]);
  const totalKm = n("end_km") ? Math.max(0, n("end_km") - n("start_km")) : 0;
  const totalHours = n("total_hours_manual") || hoursBetween(d.start_date || d.duty_date, d.start_time, d.end_date, d.end_time);
  const extraKm = n("package_km") ? Math.max(0, totalKm - n("package_km")) : 0;
  const extraHours = n("package_hours") ? Math.max(0, totalHours - n("package_hours")) : 0;
  const pass = n("toll") + n("parking") + n("state_tax");
  const allow = n("driver_allowance") + n("night_charges");
  const billing = n("package_rate") + extraKm * n("extra_km_rate") + extraHours * n("extra_hr_rate") + allow + pass + n("other_charges");
  const cost =
    d.vehicle_source === "market"
      ? n("owner_rate") + extraKm * n("owner_extra_km_rate") + extraHours * n("owner_extra_hr_rate") + allow + pass
      : n("fuel_cost") + n("driver_cost") + n("other_expense") + pass;
  return { totalKm, totalHours, extraKm, extraHours, billing, cost, profit: billing - cost, pass };
}

export const CITIES = ["Chhatrapati Sambhajinagar", "Nashik", "Shirdi", "Jalna", "Pune", "Mumbai", "Other"];
export const DUTY_STATUSES = ["Scheduled", "Ongoing", "Pending Approval", "Completed", "Billed", "Cancelled", "Rejected"];
export const DUTY_TYPES = [
  { label: "Local 8hr / 80km", km: 80, hrs: 8 },
  { label: "Local 4hr / 40km", km: 40, hrs: 4 },
  { label: "Local 12hr / 120km", km: 120, hrs: 12 },
  { label: "Airport Transfer", km: 0, hrs: 0 },
  { label: "Outstation", km: 0, hrs: 0 },
  { label: "One Way Drop", km: 0, hrs: 0 },
  { label: "Custom", km: 0, hrs: 0 },
];
export const VEHICLE_TYPES = ["Sedan (Dzire/Aura)", "Hatchback", "SUV (Ertiga)", "SUV (Innova)", "Innova Crysta", "Tempo Traveller", "Other"];
